import { tns } from 'tiny-slider/src/tiny-slider';

class PostsSlider {
	constructor(el) {
		this.el = el;
		this.sliderEl = this.el.querySelector('.block-posts__slider');
		this.navEl = this.el.querySelector('.custom-nav-container-posts');
		this.slider = null;

		if (!this.sliderEl) {
			return;
		}

		this.initSlider();
	}

	initSlider() {
		this.slider = tns({
			container: this.sliderEl,
			items: 1,
			slideBy: 1,
			mode: 'carousel',
			autoplay: false,
			autoplayButtonOutput: false,
			speed: 400,
			controls: false,
			nav: true,
			navContainer: this.navEl,
			mouseDrag: true,

			responsive: {
				640: {
					disable: true,
				},
			},
		});
	}
}

export default PostsSlider;
